export enum BusinessType {
  POS = 'POS',
  WA_FORM = 'WA_FORM',
}
